export enum CustomControlStatus {
    analysis = 'analysis',
    assetNeeded = 'assetNeeded',
    uploading = 'uploading',
    withPatient = 'withPatient',
}
